import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1722564e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "AppPreloaderAnimation fill-gray",
    viewBox: "0 0 490 460"
};
const _hoisted_2 = ["clip-path"];
const _hoisted_3 = ["clip-path"];
const _hoisted_4 = ["clip-path"];
const _hoisted_5 = ["id"];
const _hoisted_6 = ["d"];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("rect", {
    class: "WindowExit",
    fill: "none",
    x: "92",
    y: "227",
    width: "56",
    height: "48"
}, null, -1));
import { getCurrentInstance } from "vue";
import useGSAP from "@/composables/useGSAP";
import { setFPS } from "@/utils/frameToTime";
const STEPS = 3;
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppPreloaderAnimation',
    setup(__props) {
        const { uid } = getCurrentInstance();
        const gsap = useGSAP();
        const frames = setFPS(60);
        const maskShapes = [
            "m-3.056 412.792 1.068-431.6h-32.735v431.6l19.926 129.515 112.614-60.488-100.873-69.027Z",
            "m171.006 380.047-1.531-418.32-204.336 20.302 13.099 429.628L160.96 600.929l857.949-189.272-847.904-31.61Z",
            "M204.211 362.941 197.63-41.68h-32.735v428.533l341.863 39.508 158.031-18.714-460.578-44.706Z"
        ];
        function onBeforeEnter(el) {
            const $ = gsap.utils.selector(el);
            gsap.set($(".Step"), { opacity: 0 });
        }
        function onEnter(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({ onComplete });
            const stagger = frames(110);
            for (let n = 1; n < STEPS; n++) {
                const step = $(`.Step--${n}`);
                const [path] = $(`#ClipPath-${n}-${uid} > path`);
                tl
                    .set(step, { opacity: 1 }, (n - 1) * stagger)
                    .to(path, {
                    keyframes: [
                        { morphSVG: { shape: maskShapes[1], shapeIndex: 0 } },
                        { morphSVG: { shape: maskShapes[2], shapeIndex: 0 } },
                    ],
                    duration: frames(140),
                    ease: "quart.inOut"
                }, ">")
                    .set(step, { opacity: 0 }, ">");
            }
            tl
                .set($(`.Step--${STEPS}`), { opacity: 1 }, (STEPS - 1) * stagger)
                .to($(`#ClipPath-${STEPS}-${uid} > path`), {
                morphSVG: { shape: maskShapes[1], shapeIndex: 0 },
                duration: frames(130),
                ease: "quart.inOut"
            }, ">");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, {
                css: false,
                appear: "",
                onBeforeEnter: onBeforeEnter,
                onEnter: onEnter
            }, {
                default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                        _createElementVNode("path", {
                            class: "Step Step--1",
                            "clip-path": `url(#ClipPath-1-${_unref(uid)})`,
                            d: "M27 7.5c-12.4 5.6-23.167 9-27 10v148h68V0c-8.5.167-28.6 1.9-41 7.5ZM78.5 165.5V0c7 0 25.5 2.5 43.5 12.5 27.2 15.2 38.333 16.667 40.5 15.5v149l-5-11.5h-79ZM0 328V177h65v145l9.5 3L0 328ZM78.5 322V177h75l9 28.5v114l3 4H90L78.5 322ZM30.5 435l-22-14.5 95-5 64 10.5-137 9ZM194.5 424.5l133.5-8-116.5-8.5-92.5 6 75.5 10.5ZM69.5 460 42 441l156.5-10.5 67 13.5-196 16ZM321.5 442 228 429l126.5-8.5 135 10-168 11.5Z"
                        }, null, 8, _hoisted_2),
                        _createElementVNode("path", {
                            class: "Step Step--2",
                            "clip-path": `url(#ClipPath-2-${_unref(uid)})`,
                            "fill-rule": "evenodd",
                            d: "M0 17.5c3.833-1 14.6-4.4 27-10S59.5.167 68 0v165.5H0V63.824l26.049-13.776.832-2.451 3.253-2.151-9.15-4.26L0 38.84V17.5ZM78.5 0v165.5h79l5 11.5v-27.046l-7.874 14.727-6.398-10.946-7.809-3.143-51.57-112.106 32.601-6.198L146 24.313c-6.031-2.426-13.91-6.174-24-11.813C104 2.5 85.5 0 78.5 0ZM0 203.557V177h65v145l9.5 3L0 328v-60.212l27.354 19.953 5.487-.699 7.176 4.229-.397-21.556-23.963-67.148-15.657.99ZM78.5 177v145l11.5 1.5h75.5l-3-4v-114l-9-28.5h-75ZM43.802 434.126 167.5 426l-64-10.5-69.958 3.682 36.053 4.324 13.928.917v4.576H78.5l-34.698 5.127Zm281.976-17.493L194.5 424.5 119 414l48.929-3.174 3.502.62-10.889 2.227 11.722-.049 12.816 2.165-5.832-3.215 59.132 4.542-46.204-5.051-1.311-2.651-11.977.733-.02-.03L211.5 408l115.02 8.392-.742.241Zm-31.451 7.91L228 429l55.067 7.656-4.219-9.17 15.479-2.943Zm80.299 13.82L489.5 430.5l-112.154-8.308-2.72 16.171ZM69.5 460 42 441l156.5-10.5 67 13.5-156.162 12.748-3.354-1.562-33.17-3.707-2.927 7.101.521 1.346-.908.074Zm43.162-178.785 8.904-9.118-8.904-5.482L118.5 218.5l-14.427 58.421-8.589-10.306 1.145 14.6-6.298 10.02 13.742-5.725 1.145 11.165 4.581-11.165 14.823 3.702-11.96-7.997Z",
                            "clip-rule": "evenodd"
                        }, null, 8, _hoisted_3),
                        _createElementVNode("path", {
                            class: "Step Step--3",
                            "clip-path": `url(#ClipPath-3-${_unref(uid)})`,
                            "fill-rule": "evenodd",
                            d: "M9.297 14.573A218.6 218.6 0 0 0 27 7.5C39.4 1.9 59.5.167 68 0v165.5H35.707L7 94l31.116 24.5 16.466-30.325 2.707-7.97 10.575-6.993L38.116 36.5 9.297 14.573ZM78.5 0v165.5h79l5 11.5v-27.046l-7.874 14.727-6.398-10.945-7.809-3.144L100.5 125.5l7-50.5-18.652-36.514 32.602-6.198L146 24.313c-6.031-2.426-13.91-6.174-24-11.813C104 2.5 85.5 0 78.5 0ZM0 203.557V177h60.977l-45.32 25.567-15.657.99Zm4.029 124.281L74.5 325l-9.5-3V206.986l-11 53.513-13.983 30.772-7.177-4.229-5.486.699-23.325 40.097ZM78.5 285.545V322l11.5 1.5h15.838L110 291.236H90.331L78.5 285.545Zm0-23.432 11.831-25.112L96.378 177H78.5v85.113ZM97.872 177l20.628 41.5 44 12.301V205.5l-9-28.5H97.872Zm64.628 73.137-3 22.364-31.5 8.715-3.378 7.996 12.577 34.288H165.5l-3-4v-69.363ZM30.5 435l-22-14.5 3.896-.205 18.163 2.133-.647.71-5.836.805 26.482 2.505 60.32 3.272L30.5 435Zm97.751-6.422L167.5 426l-64-10.5-8.271.435 7.066 1.811 16.691 3.153-2.952 2.094 12.217 5.585Zm101.4-6.184L194.5 424.5 119 414l37.007-2.4 9.299 5.138 47.713 2.554 16.632 3.102Zm11.625-.697-9.794-4.881 1.565-6.489-23.036-1.784-5.698-.077L211.5 408l115.021 8.392-.743.241-84.502 5.064Zm53.052 2.846L228 429l55.067 7.656-4.219-9.17 15.48-2.943Zm80.298 13.82L489.5 430.5l-112.154-8.308-2.72 16.171ZM69.5 460 42 441l31.658-2.124 44.266 12.6-35.733-1.778-9.233 8.67-.57 1.396L69.5 460Zm136.032-11.105L265.5 444l-67-13.5-33.029 2.216.661.012 14.97 6.209 25.954 7.633-1.524 2.325Z",
                            "clip-rule": "evenodd"
                        }, null, 8, _hoisted_4),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(STEPS, (n) => {
                            return _createElementVNode("clipPath", {
                                key: n,
                                id: `ClipPath-${n}-${_unref(uid)}`
                            }, [
                                _createElementVNode("path", {
                                    d: maskShapes[0]
                                }, null, 8, _hoisted_6)
                            ], 8, _hoisted_5);
                        }), 64)),
                        _hoisted_7
                    ]))
                ]),
                _: 1
            }));
        };
    }
});
